import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../../fulfillment-planner/labeled-row/messages';

import LabeledRow from '../../../fulfillment-planner/labeled-row';
import getCarrierDisplayName from '../../../components/data-driven-logo/get-carrier-display-name';

import style from './style.module.less';

const Carrier = ({ carrierId }) => {
  const carrierDisplayNameMessageDescriptor = getCarrierDisplayName(carrierId);
  return (
    <LabeledRow className={style.row} label={<FormattedMessage {...messages.carrier} />} labelClassName={style.label}>
      {carrierId ? (
        <span className={style.info}>
          <FormattedMessage {...carrierDisplayNameMessageDescriptor} />
        </span>
      ) : (
        <span className={style.mdsash}>&mdash;</span>
      )}
    </LabeledRow>
  );
};

Carrier.propTypes = {
  carrierId: PropTypes.string,
};

export default Carrier;
